export const CUSTOMISATION_STEPS = ['Position', 'Application', 'Choose Artwork', 'Type', 'Edit Artwork'];
export const FINAL_STEP_INDEX = 3;
export const NUMBER_OF_STEPS = 5;
